/*
 * @Author: Fan
 * @Date: 2020-04-14 10:27:17
 * @LastEditTime: 2020-04-14 10:50:53
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /frontend/modules/@cloudpivot/form/src/typings/form-attribute.ts
 */
export var ControlAttributeType;
(function (ControlAttributeType) {
    ControlAttributeType[ControlAttributeType["Boolean"] = 0] = "Boolean";
    ControlAttributeType[ControlAttributeType["String"] = 1] = "String";
    ControlAttributeType[ControlAttributeType["Dropdown"] = 2] = "Dropdown";
    ControlAttributeType[ControlAttributeType["Modal"] = 3] = "Modal";
    ControlAttributeType[ControlAttributeType["Date"] = 4] = "Date";
    ControlAttributeType[ControlAttributeType["SelectTree"] = 5] = "SelectTree";
    ControlAttributeType[ControlAttributeType["Tree"] = 6] = "Tree";
    ControlAttributeType[ControlAttributeType["Userpicker"] = 7] = "Userpicker";
    ControlAttributeType[ControlAttributeType["Array"] = 8] = "Array";
})(ControlAttributeType || (ControlAttributeType = {}));
export var ModalAttributeType;
(function (ModalAttributeType) {
    // 单选选项框
    ModalAttributeType["RadioOption"] = "radioOption";
    // 多选选项框
    ModalAttributeType["CheckboxOption"] = "checkboxOption";
    ModalAttributeType["BizRadioOption"] = "bizRadioOption";
    // 最小日期
    ModalAttributeType["MinDate"] = "min-yyyy-mm-dd";
    // 最大日期
    ModalAttributeType["MaxDate"] = "max-yyyy-mm-dd";
    // 正则弹框
    ModalAttributeType["RegexpFormula"] = "regularModal";
    // 必填条件
    ModalAttributeType["RequiredFormula"] = "requiredCondition";
    // 显示条件
    ModalAttributeType["DisplayFormula"] = "showRule";
    // 显示条件
    ModalAttributeType["ReadonlyCondition"] = "readonlyCondition";
    // 计算规则
    ModalAttributeType["ComputeFormula"] = "calculateRule";
    // 选人控件映射关系
    ModalAttributeType["UserSelectionMap"] = "userSelectionMap";
    // 查询条件
    ModalAttributeType["QueryFormula"] = "queryCondition";
    // 事件脚本输入
    ModalAttributeType["ScriptInput"] = "ScriptInput";
    // 映射子表
    ModalAttributeType["SheetMappings"] = "sheetMappings";
    // 表单外链接
    ModalAttributeType["ExternalLink"] = "ExternalLink";
    // 数值类型 校验
    ModalAttributeType["VerifyFormulaNumber"] = "VerifyFormulaNumber";
    // 日期类型 校验
    ModalAttributeType["VerifyFormulaDate"] = "VerifyFormulaDate";
    // 图片上传数量
    ModalAttributeType["UpdateImgNum"] = "UpdateImgNum";
    /**
     * 选人控件值设置
     */
    ModalAttributeType["UserSelectValueSetting"] = "UserSelectValueSetting";
    /**
     * 选人控件组织根节点设置
     */
    ModalAttributeType["UserSelectOrgValueSetting"] = "UserSelectOrgValueSetting";
    ModalAttributeType["Print"] = "Print";
    // 关联表单默认值
    ModalAttributeType["RelevanceFormDefaultVal"] = "RelevanceFormDefaultValue";
    // 短文本几算规则
    ModalAttributeType["shortTextStitchRouls"] = "ShortTextStitchRouls";
    // 短文本几算规则
    ModalAttributeType["SelectReportData"] = "SelectReportData";
    /**
     * 标签页头部
     */
    ModalAttributeType["TabsHeadsSetting"] = "TabsHeadsSetting";
    ModalAttributeType["dataLinkage"] = "dataLinkage";
})(ModalAttributeType || (ModalAttributeType = {}));
